<script setup>
import {computed, ref} from 'vue'
// обработка формы
import {useForm} from "vee-validate";
//import axios from "axios";
import {useStore} from "vuex";
import axios from "axios";
//----------------------------------------------------------------------------------------//

// eslint-disable-next-line no-undef,no-unused-vars
const props = defineProps({
  title:{
    type: String,
    required: true,
  },
  section:{
    type: String,
    required: true,
  },
})

const store = useStore()

// обработка формы
const { handleSubmit, isSubmitting } = useForm();

// загружаемый файл
const file = ref(null)
const signature = ref(null)
const isUploadError = ref(false)
const iAgree = ref(false)
const onSubmit = handleSubmit( async ()=> {

  try {

    const headers = {
      'Content-Type': 'multipart/form-data',
      'Authorization': 'Bearer ' + token.value
    }

    let payload = {'document': props.title, 'section': props.section, 'userId': user.value.id}
    if (file.value.value !== '' && signature.value.value !== ''){
      isUploadError.value = false
      payload = {...payload, ...{'file': file.value.files[0], 'signature': signature.value.files[0]}}
    } else {
      isUploadError.value = true
    }

    if (!isUploadError.value){
      //console.log(headers)
      //console.log(payload)

      const url = process.env.VUE_APP_API + "upload-document.php"

      const {data} = await axios.post(url, payload, {
        headers: headers
      })

      //console.log(data)

      if (data['status'] == 'SUCCESS'){
        emit('create')
      } else {
        emit('close')
      }

    }

  } catch (e) {
    alert ('INTERNAL_SERVER_ERROR')
  }

})

// eslint-disable-next-line no-undef,no-unused-vars
const emit = defineEmits(['close','create'])

//----------------------------------------------------------------------
const token = computed( () => {return store.getters['authModule/token']})
const user = computed( () => {return store.getters['authModule/user']})

</script>

<template>
  <div class="dark-background"></div>
  <div class="modal fade show d-block">
    <div class="modal-dialog  modal-lg">
      <div class="modal-content">

        <div class="modal-header bg-light">
          <h4 class="modal-title">{{ props.title }}</h4>
        </div>

        <form @submit.prevent="onSubmit">
          <div class="modal-body">
            <div class="form-group mt-4">
              <label for="document">Документ (.pdf)</label>
              <div>
                <input
                    ref="file"
                    type="file"
                    class="form-control"
                    accept=".pdf"
                >
              </div>
            </div>

            <div class="form-group mt-4">
              <label for="document">Электронная цифровая подпись (.sig)</label>
              <p>Файл формата .sig содержит электронную цифровую подпись и прикрепляется к передаваемому документу в личном кабинете
                клиента СПБ ЦДЖ. Этим подтверждается подлинность документа.</p>
              <div>
                <input
                    ref="signature"
                    type="file"
                    class="form-control"
                    accept=".sig"
                >
              </div>
            </div>

            <div class="form-group mt-5">
              <div class="custom-control custom-checkbox">
                <input
                    class="custom-control-input custom-control-input-info"
                    type="checkbox"
                    id="I-agree"
                    v-model="iAgree"
                    @click="iAgree = !iAgree"
                >
                <label for="I-agree" class="custom-control-label">Подтверждаю согласие на обработку персональных данных и даю согласие на получение кредитного отчета из бюро кредитных историй</label>
              </div>
            </div>

            <div v-if="isUploadError" class="bg-danger text-center p-2 rounded">Выберите файлы для загрузки</div>

          </div>
          <div class="modal-footer justify-content-between border-0">
            <button
                type="button"
                class="btn btn-default"
                @click="$emit('close')"
            >Отмена</button>
            <button
                type="submit"
                class="btn btn-info"
                :disabled="isSubmitting || !iAgree"
                style="width: 120px"
            >
              <svg v-if="isSubmitting"
                   xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g><circle cx="3" cy="12" r="2" fill="#fff"/><circle cx="21" cy="12" r="2" fill="#fff"/><circle cx="12" cy="21" r="2" fill="#fff"/><circle cx="12" cy="3" r="2" fill="#fff"/><circle cx="5.64" cy="5.64" r="2" fill="#fff"/><circle cx="18.36" cy="18.36" r="2" fill="#fff"/><circle cx="5.64" cy="18.36" r="2" fill="#fff"/><circle cx="18.36" cy="5.64" r="2" fill="#fff"/><animateTransform attributeName="transform" dur="1.5s" repeatCount="indefinite" type="rotate" values="0 12 12;360 12 12"/></g>
              </svg>
              <span v-else>Сохранить</span>

            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<style scoped>
.input-error{color:#dc3545;margin: 5px}
</style>